// import React, { useState } from "react";
// import { FieldError, UseFormRegister, RegisterOptions } from "react-hook-form";

// type TextareaFieldProps = {
//   name: string;
//   error?: FieldError | any;
//   register?: UseFormRegister<any>;
//   validation?: RegisterOptions;
//   className?: string;
//   label?: string;
//   placeholder?: string;
//   rows?: number;
//   dir?: string;
//   lang?: string;
//   onFocus?: () => void;
// };

// const VariableTextareaField: React.FC<TextareaFieldProps> = ({
//   name,
//   error,
//   register,
//   validation,
//   className = "",
//   label,
//   placeholder = "",
//   rows = 4,
//   dir,
//   lang,
//   onFocus,
// }) => {
//   const [value, setValue] = useState("");

//   return (
//     <div className="relative flex flex-col gap-1">
//       {label && <label htmlFor={name}>{label}</label>}

//       {/* Styled Placeholder */}
//       {value.trim() === "" && (
//         <div className="absolute px-4 py-4 pointer-events-none text-sm text-gray-400 leading-6">
//           Your order{" "}
//           <span className="p-1 w-fit text-xs border border-[#D2D2D2] rounded-md bg-[#007BFF1A] text-[#007BFF]">
//             orderId
//           </span>{" "}
//           has been{" "}
//           <span className="p-1  w-fit text-xs border border-[#D2D2D2] rounded-md bg-[#007BFF1A] text-[#007BFF]">
//             Status
//           </span>
//         </div>
//       )}

//       <textarea
//         id={name}
//         {...(register && register(name, validation))}
//         rows={rows}
//         value={value}
//         onChange={(e) => setValue(e.target.value)}
//         className={` border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 py-2 text-sm outline-none ${className}`}
//       />

//       {error && <span className="text-red-500 text-xs">{error}</span>}
//     </div>
//   );
// };

// export default VariableTextareaField;

import React from "react";
import { FieldError, UseFormRegister, RegisterOptions } from "react-hook-form";

type TextareaFieldProps = {
  name: string;
  error?: FieldError | any;
  register?: UseFormRegister<any>;
  validation?: RegisterOptions;
  className?: string;
  label?: string;
  placeholder?: string;
  rows?: number;
};

const VariableTextareaField: React.FC<TextareaFieldProps> = ({
  name,
  error,
  register,
  validation,
  className = "",
  label,
  placeholder = "",
  rows = 4,
}) => {
  return (
    <div className="relative flex flex-col gap-1">
      {label && <label htmlFor={name}>{label}</label>}

      <textarea
        id={name}
        {...(register && register(name, validation))}
        rows={rows}
        placeholder={placeholder}
        className={`border border-[#D8D8D8] bg-white resize-none rounded-2xl px-4 py-2 text-sm outline-none ${className}`}
      />

      {error && <span className="text-red-500 text-xs">{error}</span>}
    </div>
  );
};

export default VariableTextareaField;
